import client from "~/apis/client"

export function fetchIcalFeeds() {
  return client.get("/settings")
}

export function syncIcalFeeds() {
  return client.post("/settings/sync")
}

export function updateIcalFeed(id, url) {
  return client.patch(`/ical_feeds/${id}`, { url })
}

export function createIcalFeed({ propertyId, source, url }) {
  return client.post("/ical_feeds", { property_id: propertyId, source, url })
}
